var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Seed, Property, html } from '@nutmeg/seed';
export class HelloWorld extends Seed {
    constructor() {
        super();
    }
    /** The component instance has been inserted into the DOM. */
    connectedCallback() {
        super.connectedCallback();
    }
    /** The component instance has been removed from the DOM. */
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    /** Watch for changes to these attributes. */
    static get observedAttributes() {
        return super.observedAttributes;
    }
    /** Rerender when the observed attributes change. */
    attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);
    }
    /** Styling for the component. */
    get styles() {
        return html `
      <style>
        :host {
          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0 ,0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
        }

        .content {
          background-color: var(--hello-world-background-color, #FAFAFA);
          color: #212121;
          padding: 16px;
        }
      </style>
    `;
    }
    /** HTML Template for the component. */
    get template() {
        return html `
      <div class="content">
        Welcome to &lt;hello-world&gt;

        <ul>
          <li>name: ${this.name}</li>
        </ul>

        <slot></slot>
      </div>
    `;
    }
}
__decorate([
    Property(),
    __metadata("design:type", String)
], HelloWorld.prototype, "name", void 0);
window.customElements.define('hello-world', HelloWorld);
//# sourceMappingURL=hello-world.js.map


//////////////////
// WEBPACK FOOTER
// ./dist/hello-world.js
// module id = ./dist/hello-world.js
// module chunks = 0 1